import { useEffect, useState } from 'react';
import { consentCategoryMeasurementGiven } from '@/app/common/utils/consentCategoryMeasurementGiven';
import { watchForConsent } from '@/app/common/ccm/consentWatch';

// Takes the plain flag, not the object the check expects. The object is built here, on each call,
// so the hook below can depend on `isLocal` alone: a fresh object on every render would restart
// the watch on every render.
const hasMeasurementConsent = (isLocal?: boolean): boolean =>
  consentCategoryMeasurementGiven(isLocal != null ? { isLocal } : undefined);

const useCookieConsent = (isLocal?: boolean): boolean => {
  const [hasConsent, setHasConsent] = useState<boolean>(() => hasMeasurementConsent(isLocal));

  useEffect(() => {
    if (hasConsent) return undefined;

    return watchForConsent(() => {
      if (hasMeasurementConsent(isLocal)) setHasConsent(true);
    });
  }, [hasConsent, isLocal]);

  return hasConsent;
};

export default useCookieConsent;
